import React, { useState, useEffect, useCallback } from 'react';
import { QuoteDetailsSection } from './QuoteDetailStyled';
import { Box, Button, TextField } from "@mui/material";
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ModeEditIcon from '@mui/icons-material/ModeEdit';
import DeliveryTable from '../utilities/DeliveryTable/DeliveryTable'
import TaskComponentTable from '../utilities/TaskComponentTable/TaskComponentTable'
import ServiceDistributionTable from './ServiceDistributionTable/ServiceDistributionTable'
import ObjectTable from '../utilities/ObjectTable/ObjectTable'
import SaveIcon from "@mui/icons-material/Save";
import { ApiCalls, ENHANCEDLEGALFINANCIALCOMPONENTENUM, ExtCostVariationComponent } from './Content';
import { useDispatch } from 'react-redux';
import { saveDeliveryStaffProductivityVariationAsync, saveStaffCostDepartmentVariationAsync, saveSessionUsageComponentTypeVariationAsync, saveExternalCostsVariationAsync, saveServiceDistribution, SaveQuoteCalculations, saveCountryUtilizationVariation } from "../../Actions/QuoteAction";
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';
import { Severity } from '../utilities/Notification/NotificationContent';
import Notification from "../utilities/Notification/Notification";
import ScrollToTopButton from '../utilities/ScrollTopButton/ScrollToTopButton'
import { QuoteStatus,AllProductsEnum,Constant } from '../QuoteRequest/Content';
import Loader from '../utilities/Loader/Loader';
import { red } from '@mui/material/colors';
import { QuoteDetailsConstants } from '../Dashboard/QuoteDetail/Content';
import { Congiguration } from '../../Constants/AppConstants';
//Data structure to save for % Delivery WPO and Ext affiliates cost
const DeliveryWPOExAffiliatesSaveObj = {
    quoteId: '',
    countryId: 0,
    companyId: 0,
    userId: 0,
    deliveryStaffProductivityTypes: [],
};

//Data structure to save for SessionModel Usages 
const SessionModelUsagesSaveObj = {
    quoteId: '',
    countryId: 0,
    companyId: 0,
    userId: 0,
    sessionUsageComponentTypes: [],
};

//Data structure to save for Component-Task-CostMin
const ComponentTaskCostMinSaveObj = {
    quoteId: '',
    countryId: 0,
    companyId: 0,
    userId: 0,
    staffCostDepartmentTypes: [],
};

//Data structure to save for External-Cost-Variation
const ExtCostVariationSaveObj = {
    quoteId: '',
    countryId: 0,
    companyId: 0,
    userId: 0,
    externalCostsTypes: [
        {
            ssT_Cost: 0,
            f2F_Cost: 0,
            svC_Cost: 0,
            stC_Cost: 0,
            core_Cost: 0,
            lF_Cost: 0,
            gA_Clinical: 0,
            gA_WL: 0,
            managementFee: 0,
            pepM_Cost: 0
        }
    ],
};

// Data structure to save Service-Distribution
const ServiceDistributionSaveObj = {
    serviceDistributionVariations: [],
    quoteId: '',
    companyId: 0,
    userId: 0
}

//Price Table
const priceData = [
    { id: 'pricingStructureName', label: '' },
    { id: 'allInPrice', label: 'All in price' },
    { id: 'clinical', label: 'Clinical' },
    { id: 'wl', label: 'WL Core*' },
    { id: 'lf', label: 'WL Legal & Financial' },
    { id: 'web', label: 'Web' }
];

//Price Table
const wellnessCoachingPriceDataHeader = [
    { id: 'pricingStructureName', label: '' },
    { id: 'allInPrice', label: 'All in price' },
    { id: 'wellnessCoaching', label: 'Wellness Coaching' },
];

const QuoteDetail = ({ quotePricing, pricing, quoteObj, loggedUser, updateCalculationsAndRefreshPage }) => {// , error}) => {

    const dispatch = useDispatch();

    useEffect(() => {
        if( !quotePricing||Object.keys(quotePricing).length === 0||!pricing||Object.keys(pricing).length === 0
        ||!quoteObj||Object.keys(quoteObj).length === 0||!loggedUser||Object.keys(loggedUser).length === 0)
        {
            setLoadingState(true);
        }
        else{
            setLoadingState(false);
            setpercentDeliveryWPOExAffiliates(quotePricing?.percentDeliveryWPOExAffiliates);
            setcomponentSessionModelUsages(quotePricing?.componentSessionModelUsages);
            setcomponentTaskCosts(quotePricing?.componentTaskCosts);
            setcountryCurrencyComponentCosts(quotePricing?.countryCurrencyComponentCosts);
            setcomponentServiceDistributions(quotePricing?.componentServiceDistributions);
            setProduct(quotePricing?.countryHeadCount[0]?.productName);
            setTotslheadount(quotePricing?.countryHeadCount.reduce((sum, obj) => sum + (obj["headcount"] || 0), 0));
            setCurrencyCode(quotePricing?.countryHeadCount[0]?.currencyCode);
        }
}, [quotePricing,quoteObj,pricing]);

    const [loading, setLoading] = useState(false);
    const [loadingText, setLoadingText] = useState('Loading please wait');
    const [showNotification, setShowNotification] = useState(true);
    const [product, setProduct] = useState('');
    const [totslheadount, setTotslheadount] = useState('');
    const [currencyCode, setCurrencyCode] = useState('');
    const [notificationMessage, setNotificationMessage] = useState('');
    const [notificationSeverity, setNotificationSeverity] = useState('');
    const [iseditable, SetisEditable] = useState(false);
    const [isEditQuoteStatus, setIsEditQuoteStatus] = useState(quoteObj?.quoteStatusId === QuoteStatus.QUOTEPENDINGPRICINGTEAM || quoteObj?.quoteStatusId === QuoteStatus.QUOTEPENDINGSAMLEADERSHIP);
    const [activeCountry, SetActiveCountry] = useState('');
    const [TaskCosts, setcomponentTaskCosts] = useState(quotePricing?.componentTaskCosts);
    const [saveTaskCosts, setSaveComponentTaskCosts] = useState([]);
    const [DeliveryWPOExAffiliates, setpercentDeliveryWPOExAffiliates] = useState(quotePricing?.percentDeliveryWPOExAffiliates);
    const [saveDeliveryWPOExAffiliates, setSaveDeliveryWPOExAffiliates] = useState([]);
    const [SessionModelUsages, setcomponentSessionModelUsages] = useState(quotePricing?.componentSessionModelUsages);
    const [saveSessionModelUsages, setSaveSessionModelUsages] = useState([]);
    const [CurrencyComponentCosts, setcountryCurrencyComponentCosts] = useState(quotePricing?.countryCurrencyComponentCosts);
    const [saveCurrencyComponentCosts, setSaveCountryCurrencyComponentCosts] = useState([]);
    const [ServiceDistributions, setcomponentServiceDistributions] = useState(quotePricing?.componentServiceDistributions);
    const [saveServiceDistributions, setSavecomponentServiceDistributions] = useState([]);
    const [newQuotePricing, setQuotePricing] = useState(quotePricing);
    const [costMinErrorValue, setCostMinErrorValue] = useState(null);
    const [deliveryErrorValue, setDeliveryErrorValue] = useState(null);
    const [sessionUsageErrorValue, setSessionUsageErrorValue] = useState(null);
    const [currencyComponentCostErrorValue, setCurrencyComponentCostErrorValue] = useState(null);
    const [serviceDistributionErrorValue, setServiceDistributionErrorValue] = useState(null);
    const [sessionUsageErrorArrayValue, setSessionUsageErrorArrayValue] = useState([]);
    const [costMinChangeErrorArrayValue, setCostMinChangeErrorArrayValue] = useState([]);
    const [delivaryErrorArrayValue, setDelivaryErrorArrayValue] = useState([]);
    const [currencyComponentCostErrorArrayValue, setCurrencyComponentCostErrorArrayValue] = useState([]);
    const [serviceDistributionErrorArrayValue, setServiceDistributionErrorArrayValue] = useState([]);
    const [loadingState, setLoadingState] = useState(false);
    const [pricingdata, setPricingData] = useState(pricing?.countryHeadCountAllInPrices);
    const [countryUtilizationToSave, setCountryUtilizationToSave] = useState(null);
    const [countryUtilizationError, setCountryUtilizationError] = useState('');
    const [allInPriceHeader, setAllInPriceHeader] = useState(quoteObj?.productId === AllProductsEnum.WELLNESSCOACHING ? wellnessCoachingPriceDataHeader : priceData);
    pricingdata?.map((x) => {
        if (!x.pricingStructureName.includes("(USD)") && !x.pricingStructureName.includes(`(${quoteObj?.currencyCode})`) && !x.pricingStructureName.includes('Product Distribution %')) {
            x.pricingStructureName = x.pricingStructureName + ` (${quoteObj?.currencyCode})`;
        }
        return x;
    });

    //Infinite scroll

    const [visibleData, setVisibleData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [pageNumber, setPageNumber] = useState(1);
    const itemsPerPage = 10; 

    useEffect(() => {
        fetchData();
    }, [quotePricing?.countryHeadCount]); 

    const fetchData = useCallback(() => {
        setTimeout(() => {
            // debugger
            const start = (pageNumber - 1) * itemsPerPage;
            const end = pageNumber * itemsPerPage;
            const newData = quotePricing?.countryHeadCount?.slice(start, end);
            if(newData)
            {console.log("New Data:", newData); // Log the new data
            setVisibleData(prevData => [...prevData, ...newData]);
            setPageNumber(prevPageNumber => prevPageNumber + 1);
            setIsLoading(false);}
        }, 1000);
    },[pageNumber, quotePricing?.countryHeadCount]);
    useEffect(() => {
        const handleScroll = (e) => {
          if ( parseInt(window.innerHeight + e.target.documentElement.scrollTop) >
          e.target.documentElement.offsetHeight-200 && !isLoading&&quotePricing?.countryHeadCount?.length>10) {
              setIsLoading(true);
              fetchData();            
          }
        };
        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
      });   

    //Infinite scroll end
    const handleCostMinChange = (componentId, taskId, countryId, newCostMin) => {
        const error = {
            isError: false,
            countryId: 0,
            componentId: 0,
            errorField: null,
            errorTable: 'Component - Task',
            errorMessage: null,
        };

        if (!newCostMin || isNaN(newCostMin) || newCostMin === "" || !/^[0-9]*\.?[0-9]*$/.test(newCostMin)) {

            error.isError = true;
            error.errorField = taskId;
            error.countryId = countryId;
            error.componentId = componentId;
            error.errorMessage = newCostMin === "" ? 'Field cannot be left blank!' : 'Please enter a valid numeric value!';
            setCostMinErrorValue(error);
            console.log('Entered invalid value : ', newCostMin);
            const findIndex = costMinChangeErrorArrayValue?.findIndex(item => item.componentId === componentId && item.countryId === countryId && item.errorField === taskId)
            if (findIndex !== -1) {
                costMinChangeErrorArrayValue[findIndex].errorMessage = error.errorMessage;
                costMinChangeErrorArrayValue[findIndex].isError = error.isError;
            }
            else {

                setCostMinChangeErrorArrayValue(prevArray => [...prevArray, error]);
            }
            return false;
        } else {
            error.isError = false;
            error.errorField = taskId;
            error.countryId = countryId;
            error.componentId = componentId;
            error.errorMessage = '';
            setCostMinErrorValue(error);
            const findIndex = costMinChangeErrorArrayValue.findIndex(item => item.componentId === componentId && item.countryId === countryId && item.errorField === taskId)
            if (findIndex !== -1) {
                costMinChangeErrorArrayValue[findIndex].errorMessage = error.errorMessage;
                costMinChangeErrorArrayValue[findIndex].isError = error.isError;
            }
            else {

                setCostMinChangeErrorArrayValue(prevArray => [...prevArray, error]);
                
            }
        }


        const currentValues = [...TaskCosts];
        const index = currentValues.findIndex(item => item.countryId === countryId && item.componentId === componentId && item.taskId === taskId);
        let modifiedObj = currentValues?.find(item => item.countryId === countryId && item.componentId === componentId && item.taskId === taskId);
        modifiedObj.costMin = parseFloat(newCostMin);

        currentValues.splice(index, 1, modifiedObj);
        setcomponentTaskCosts([...currentValues]);

        let foundIndex;
        let currentObj;
        if (newCostMin !== '') {

            currentObj = {
                componentId: (modifiedObj.componentId === ENHANCEDLEGALFINANCIALCOMPONENTENUM.ENHANCEDLEGAL
                    || modifiedObj.componentId === ENHANCEDLEGALFINANCIALCOMPONENTENUM.ENHANCEDFINANCIAL)
                    ? null : modifiedObj.componentId,
                taskId: modifiedObj.taskId,
                costMin: modifiedObj.costMin,
            };
        } else {
            currentObj = {
                componentId: (modifiedObj.componentId === ENHANCEDLEGALFINANCIALCOMPONENTENUM.ENHANCEDLEGAL
                    || modifiedObj.componentId === ENHANCEDLEGALFINANCIALCOMPONENTENUM.ENHANCEDFINANCIAL)
                    ? null : modifiedObj.componentId,
                taskId: (isNaN(modifiedObj.taskId) || modifiedObj.taskId === '') ? 0 : modifiedObj.taskId,
                costMin: (isNaN(modifiedObj.costMin) || modifiedObj.costMin === '') ? 0 : modifiedObj.costMin,
            };
        }
        //check if already present in save list
        const currentSaveList = [...saveTaskCosts];

        if (currentSaveList.length > 0 && currentSaveList[0].countryId === countryId) {

            foundIndex = currentSaveList[0].staffCostDepartmentTypes.findIndex((x) => x.componentId === currentObj.componentId
                && x.taskId === currentObj.taskId);
        } else { foundIndex = -1; }

        if (foundIndex !== -1) {
            currentSaveList[0].staffCostDepartmentTypes.splice(foundIndex, 1, currentObj);
        } else {

            if (currentSaveList.length > 0) {
                currentSaveList[0].staffCostDepartmentTypes.push(currentObj);
            } else {
                const ComponentTaskCostMinSaveObject = {
                    quoteId: '',
                    countryId: 0,
                    companyId: 0,
                    userId: 0,
                    staffCostDepartmentTypes: [],
                };
                ComponentTaskCostMinSaveObject.quoteId = quoteObj?.quoteId;
                ComponentTaskCostMinSaveObject.countryId = countryId;
                ComponentTaskCostMinSaveObject.companyId = quoteObj?.companyId;
                ComponentTaskCostMinSaveObject.userId = loggedUser?.user?.id;
                ComponentTaskCostMinSaveObject.staffCostDepartmentTypes.push(currentObj);

                currentSaveList.push(ComponentTaskCostMinSaveObject);
            }
        }
        console.log('currentSaveList ComponentTaskCostMinSaveObj: ', currentSaveList);
        setSaveComponentTaskCosts(currentSaveList);

    };
    const handleDelivaryChange = (componentId, countryId, field, newValue) => {

        const error = {
            extAffiliateDeliveredIsError: false,
            wpoDeliveredPercentIsError: false,
            countryId: 0,
            componentId: 0,
            wpoDeliveredPercentErrorField: null,
            wpoDeliveredValue: 0,
            extAffiliateDeliveredValue: 0,
            extAffiliateDeliveredErrorField: null,
            errorTable: 'Component - % Delivery (WPO/Ext. Affiliate)',
            wpoDeliveredPercentErrorMessage: null,
            extAffiliateDeliveredErrorMessage: null,
        };

        if (isNaN(newValue) || newValue === "" || !/^[0-9]*\.?[0-9]*$/.test(newValue)) {
            if ("extAffiliateDelivered" === field) {
                error.extAffiliateDeliveredIsError = true;
                error.extAffiliateDeliveredErrorField = field;
                error.countryId = countryId;
                error.componentId = componentId;
                error.extAffiliateDeliveredValue = newValue;
                error.extAffiliateDeliveredErrorMessage = newValue === "" ? 'Field cannot be left blank!' : 'Please enter a valid numeric value!';
                setDeliveryErrorValue(error);
                console.log('Entered invalid value : ', newValue);
                const findIndex = delivaryErrorArrayValue?.findIndex(item => item.componentId === componentId && item.countryId === countryId)

                if (findIndex !== -1) {
                    delivaryErrorArrayValue[findIndex].extAffiliateDeliveredErrorMessage = error.extAffiliateDeliveredErrorMessage;
                    delivaryErrorArrayValue[findIndex].extAffiliateDeliveredIsError = error.extAffiliateDeliveredIsError;
                    delivaryErrorArrayValue[findIndex].extAffiliateDeliveredErrorField = error.extAffiliateDeliveredErrorField;
                    delivaryErrorArrayValue[findIndex].extAffiliateDeliveredValue = error.extAffiliateDeliveredValue;
                }
                else {
                    setDelivaryErrorArrayValue(prevArray => [...prevArray, error]);

                }
            }
            else if ("wpoDeliveredPercent" === field) {

                error.wpoDeliveredPercentIsError = true;
                error.wpoDeliveredPercentErrorField = field;
                error.countryId = countryId;
                error.componentId = componentId;
                error.wpoDeliveredValue = newValue;
                error.wpoDeliveredPercentErrorMessage = newValue === "" ? 'Field cannot be left blank!' : 'Please enter a valid numeric value!';
                setDeliveryErrorValue(error);
                console.log('Entered invalid value : ', newValue);
                const findIndex = delivaryErrorArrayValue?.findIndex(item => item.componentId === componentId && item.countryId === countryId)
                if (findIndex !== -1) {
                    delivaryErrorArrayValue[findIndex].wpoDeliveredPercentErrorMessage = error.wpoDeliveredPercentErrorMessage;
                    delivaryErrorArrayValue[findIndex].wpoDeliveredPercentIsError = error.wpoDeliveredPercentIsError;
                    delivaryErrorArrayValue[findIndex].wpoDeliveredPercentErrorField = error.wpoDeliveredPercentErrorField;
                    delivaryErrorArrayValue[findIndex].wpoDeliveredValue = error.wpoDeliveredValue;
                }
                else {
                    setDelivaryErrorArrayValue(prevArray => [...prevArray, error]);

                }

            }
            const currentValues = [...DeliveryWPOExAffiliates];
            const index = currentValues.findIndex(item => item.componentId === componentId && item.countryId === countryId);
            let modifiedObj = currentValues?.find(item => item.componentId === componentId && item.countryId === countryId);
            modifiedObj[field] = newValue;
            currentValues.splice(index, 1, modifiedObj);
            setpercentDeliveryWPOExAffiliates([...currentValues])
            return false;

        } else {
            if ("extAffiliateDelivered" === field) {
                error.extAffiliateDeliveredIsError = false;
                error.extAffiliateDeliveredErrorField = field;
                error.countryId = countryId;
                error.componentId = componentId;
                error.extAffiliateDeliveredValue = newValue;
                error.extAffiliateDeliveredErrorMessage = "";
                
                console.log('Entered invalid value : ', newValue);
                const findIndex = delivaryErrorArrayValue?.findIndex(item => item.componentId === componentId && item.countryId === countryId)
                if (findIndex !== -1) {
                    delivaryErrorArrayValue[findIndex].extAffiliateDeliveredErrorMessage = error.extAffiliateDeliveredErrorMessage;
                    delivaryErrorArrayValue[findIndex].extAffiliateDeliveredIsError = error.extAffiliateDeliveredIsError;
                    delivaryErrorArrayValue[findIndex].extAffiliateDeliveredErrorField = error.extAffiliateDeliveredErrorField;
                    delivaryErrorArrayValue[findIndex].extAffiliateDeliveredValue = error.extAffiliateDeliveredValue;
                }
                else {
                    setDelivaryErrorArrayValue(prevArray => [...prevArray, error]);

                }
            }
            else if ("wpoDeliveredPercent" === field) {

                error.wpoDeliveredPercentIsError = false;
                error.wpoDeliveredPercentErrorField = field;
                error.countryId = countryId;
                error.componentId = componentId;
                error.wpoDeliveredValue = newValue;
                error.wpoDeliveredPercentErrorMessage = "";
               
                console.log('Entered invalid value : ', newValue);
                const findIndex = delivaryErrorArrayValue?.findIndex(item => item.componentId === componentId && item.countryId === countryId)
                if (findIndex !== -1) {
                    delivaryErrorArrayValue[findIndex].wpoDeliveredPercentErrorMessage = error.wpoDeliveredPercentErrorMessage;
                    delivaryErrorArrayValue[findIndex].wpoDeliveredPercentIsError = error.wpoDeliveredPercentIsError;
                    delivaryErrorArrayValue[findIndex].wpoDeliveredPercentErrorField = error.wpoDeliveredPercentErrorField;
                    delivaryErrorArrayValue[findIndex].wpoDeliveredValue = error.wpoDeliveredValue;
                }
                else {
                    setDelivaryErrorArrayValue(prevArray => [...prevArray, error]);
                }
            }
            const currentValues = [...DeliveryWPOExAffiliates];
            const index = currentValues.findIndex(item => item.componentId === componentId && item.countryId === countryId);
            let modifiedObj = currentValues?.find(item => item.componentId === componentId && item.countryId === countryId);
            modifiedObj[field] = parseFloat(newValue);
            currentValues.splice(index, 1, modifiedObj);
            setpercentDeliveryWPOExAffiliates([...currentValues]);
          }
        const currentValues = [...DeliveryWPOExAffiliates];
        const index = currentValues.findIndex(item => item.componentId === componentId && item.countryId === countryId);
        let modifiedObj = currentValues?.find(item => item.componentId === componentId && item.countryId === countryId);
        modifiedObj[field] = parseFloat(newValue);
        currentValues.splice(index, 1, modifiedObj);
        setpercentDeliveryWPOExAffiliates([...currentValues]);

        if ((modifiedObj.wpoDeliveredPercent + modifiedObj.extAffiliateDelivered) !== 100) {

            error.wpoDeliveredPercentIsError = true;
            error.wpoDeliveredPercentErrorField = "wpoDeliveredPercent";
            error.countryId = countryId;
            error.componentId = componentId;
            error.wpoDeliveredPercentErrorMessage = " 'Total of WPO and Ext. Affiliate should be 100!';";
            error.extAffiliateDeliveredIsError = true;
            error.extAffiliateDeliveredErrorField = "extAffiliateDelivered";
            error.extAffiliateDeliveredErrorMessage = 'Total of WPO and Ext. Affiliate should be 100!';
            const findIndex = delivaryErrorArrayValue.findIndex(item => item.componentId === componentId && item.countryId === countryId)
            if (findIndex !== -1) {
                delivaryErrorArrayValue[findIndex].wpoDeliveredPercentIsError = error.wpoDeliveredPercentIsError;
                delivaryErrorArrayValue[findIndex].wpoDeliveredPercentErrorMessage = error.wpoDeliveredPercentErrorMessage;
                delivaryErrorArrayValue[findIndex].wpoDeliveredPercentErrorField = error.wpoDeliveredPercentErrorField;
                delivaryErrorArrayValue[findIndex].wpoDeliveredValue = error.wpoDeliveredValue;
                delivaryErrorArrayValue[findIndex].extAffiliateDeliveredErrorMessage = error.extAffiliateDeliveredErrorMessage;
                delivaryErrorArrayValue[findIndex].extAffiliateDeliveredIsError = error.extAffiliateDeliveredIsError;
                delivaryErrorArrayValue[findIndex].extAffiliateDeliveredErrorField = error.extAffiliateDeliveredErrorField;
            }
            else {
                setDelivaryErrorArrayValue(prevArray => [...prevArray, error]);
            }
            setDeliveryErrorValue(error);
            return false;
        }
        else {
            error.wpoDeliveredPercentIsError =false;
            error.wpoDeliveredPercentErrorField = "wpoDeliveredPercent";
            error.countryId = countryId;
            error.componentId = componentId;
            error.wpoDeliveredPercentErrorMessage = "";
            error.extAffiliateDeliveredIsError = false;
            error.extAffiliateDeliveredErrorField = "extAffiliateDelivered";
            error.extAffiliateDeliveredErrorMessage = "";
            const findIndex = delivaryErrorArrayValue.findIndex(item => item.componentId === componentId && item.countryId === countryId)
            if (findIndex !== -1) {
                delivaryErrorArrayValue[findIndex].wpoDeliveredPercentIsError = error.wpoDeliveredPercentIsError;
                delivaryErrorArrayValue[findIndex].wpoDeliveredPercentErrorMessage = error.wpoDeliveredPercentErrorMessage;
                delivaryErrorArrayValue[findIndex].wpoDeliveredPercentErrorField = error.wpoDeliveredPercentErrorField;
                delivaryErrorArrayValue[findIndex].wpoDeliveredValue = error.wpoDeliveredValue;
                delivaryErrorArrayValue[findIndex].extAffiliateDeliveredErrorMessage = error.extAffiliateDeliveredErrorMessage;
                delivaryErrorArrayValue[findIndex].extAffiliateDeliveredIsError = error.extAffiliateDeliveredIsError;
                delivaryErrorArrayValue[findIndex].extAffiliateDeliveredErrorField = error.extAffiliateDeliveredErrorField;

            }
            else {

                setDelivaryErrorArrayValue(prevArray => [...prevArray, error]);
              
            }
        }



        let foundIndex;
        let currentObj;
        if (newValue !== '') {

            currentObj = {
                componentId: (modifiedObj.componentId === ENHANCEDLEGALFINANCIALCOMPONENTENUM.ENHANCEDLEGAL
                    || modifiedObj.componentId === ENHANCEDLEGALFINANCIALCOMPONENTENUM.ENHANCEDFINANCIAL)
                    ? null : modifiedObj.componentId,
                wpoDeliveredPercent: modifiedObj.wpoDeliveredPercent,
                extAffiliateDelivered: modifiedObj.extAffiliateDelivered,
            };
        } else {
            currentObj = {
                componentId: (modifiedObj.componentId === ENHANCEDLEGALFINANCIALCOMPONENTENUM.ENHANCEDLEGAL
                    || modifiedObj.componentId === ENHANCEDLEGALFINANCIALCOMPONENTENUM.ENHANCEDFINANCIAL)
                    ? null : modifiedObj.componentId,
                extAffiliateDelivered: (isNaN(modifiedObj.extAffiliateDelivered) || modifiedObj.extAffiliateDelivered === '') ? 0
                    : modifiedObj.extAffiliateDelivered,
                wpoDeliveredPercent: (isNaN(modifiedObj.wpoDeliveredPercent) || modifiedObj.wpoDeliveredPercent === '') ? 0
                    : modifiedObj.wpoDeliveredPercent,
            };
        }
        //check if already present in save list
        const currentSaveList = [...saveDeliveryWPOExAffiliates];

        if (currentSaveList.length > 0 && currentSaveList[0].countryId === countryId) {

            foundIndex = currentSaveList[0].deliveryStaffProductivityTypes.findIndex((x) => x.componentId === currentObj.componentId);
        } else { foundIndex = -1; }

        if (foundIndex !== -1) {
            currentSaveList[0].deliveryStaffProductivityTypes.splice(foundIndex, 1, currentObj);
        } else {

            if (currentSaveList.length > 0) {
                currentSaveList[0].deliveryStaffProductivityTypes.push(currentObj);
            } else {
                const DeliveryWPOExAffiliatesSaveObject = {
                    quoteId: '',
                    countryId: 0,
                    companyId: 0,
                    userId: 0,
                    deliveryStaffProductivityTypes: [],
                };

                DeliveryWPOExAffiliatesSaveObject.quoteId = quoteObj?.quoteId;
                DeliveryWPOExAffiliatesSaveObject.countryId = countryId;
                DeliveryWPOExAffiliatesSaveObject.companyId = quoteObj?.companyId;
                DeliveryWPOExAffiliatesSaveObject.userId = loggedUser?.user?.id;
                DeliveryWPOExAffiliatesSaveObject.deliveryStaffProductivityTypes.push(currentObj);

                currentSaveList.push(DeliveryWPOExAffiliatesSaveObject);
            }
        }
        console.log('currentSaveList deliveryStaffProductivityTypes: ', currentSaveList);
        setSaveDeliveryWPOExAffiliates(currentSaveList);
    };

    const handleSessionModelUsagesChange = (componentId, countryId, field, newValue) => {
        const error = {
            isError: false,
            countryId: 0,
            componentId: 0,
            errorField: null,
            errorTable: 'Component - Session Model Usage %',
            errorMessage: null,
        };

        if (isNaN(newValue) || newValue === "" || !/^[0-9]*\.?[0-9]*$/.test(newValue)) {

            error.isError = true;
            error.errorField = field;
            error.countryId = countryId;
            error.componentId = componentId;
            error.errorMessage = newValue === "" ? 'Field cannot be left blank!' : 'Please enter a valid numeric value!';
            setSessionUsageErrorValue(error);
            
            console.log('Entered invalid value : ', newValue);
            const findIndex = sessionUsageErrorArrayValue.findIndex(item => item.componentId === componentId && item.countryId === countryId && item.errorField === field)
            if (findIndex !== -1) {
                sessionUsageErrorArrayValue[findIndex].errorMessage = error.errorMessage;
                sessionUsageErrorArrayValue[findIndex].isError = error.isError;
            }
            else {
               
                setSessionUsageErrorArrayValue(prevArray => [...prevArray, error]);
              
            }
            return false;
        } else if (newValue > 100) {
            error.isError = true;
            error.errorField = field;
            error.countryId = countryId;
            error.componentId = componentId;
            error.errorMessage = 'Value should be less than 100!';
            setSessionUsageErrorValue(error);
            console.log('Entered invalid value : ', newValue);
            const findIndex = sessionUsageErrorArrayValue.findIndex(item => item.componentId === componentId && item.countryId === countryId && item.errorField === field)
            if (findIndex !== -1) {
                sessionUsageErrorArrayValue[findIndex].errorMessage = error.errorMessage;
                sessionUsageErrorArrayValue[findIndex].isError = error.isError;
            }
            else {

                setSessionUsageErrorArrayValue(prevArray => [...prevArray, error]);
                
            }
            return false;
        }
        else {
            error.isError = false;
            error.errorField = field;
            error.countryId = countryId;
            error.componentId = componentId;
            error.errorMessage = '';
            setSessionUsageErrorValue(error);
            const findIndex = sessionUsageErrorArrayValue.findIndex(item => item.componentId === componentId && item.countryId === countryId && item.errorField === field)
            if (findIndex !== -1) {
                sessionUsageErrorArrayValue[findIndex].errorMessage = error.errorMessage;
                sessionUsageErrorArrayValue[findIndex].isError = error.isError;
            }
            else {

                setSessionUsageErrorArrayValue(prevArray => [...prevArray, error]);
                
            }
        }
        const currentValues = [...SessionModelUsages];
        const index = currentValues.findIndex(item => item.componentId === componentId && item.countryId === countryId);
        let modifiedObj = currentValues?.find(item => item.componentId === componentId && item.countryId === countryId);
        modifiedObj[field] = parseFloat(newValue);
        currentValues.splice(index, 1, modifiedObj);
        setcomponentSessionModelUsages([...currentValues]);
        let foundIndex;
        let currentObj;
        if (newValue !== '') {

            currentObj = {
                componentId: modifiedObj.componentId,
                noOfSessions: modifiedObj.noOfSessions,
                usage: modifiedObj.usage,
            };

        } else {

            currentObj = {
                componentId: modifiedObj.componentId,
                noOfSessions: (isNaN(modifiedObj.noOfSessions) || modifiedObj.noOfSessions === '') ? 0
                    : modifiedObj.noOfSessions,
                usage: (isNaN(modifiedObj.sessionmodelsUsage) || modifiedObj.sessionmodelsUsage === '') ? 0
                    : modifiedObj.usage,
            };
        }

        //check if already present in save list
        const currentSaveList = [...saveSessionModelUsages];

        if (currentSaveList.length > 0 && currentSaveList[0].countryId === countryId) {
            foundIndex = currentSaveList[0].sessionUsageComponentTypes
                .findIndex((x) => x.componentId === currentObj.componentId
                );
        } else { foundIndex = -1; }

        if (foundIndex !== -1) {
            currentSaveList[0].sessionUsageComponentTypes.splice(foundIndex, 1, currentObj);
        } else {

            if (currentSaveList.length > 0) {
                currentSaveList[0].sessionUsageComponentTypes.push(currentObj);
            } else {
                const SessionModelUsagesSaveObject = {
                    quoteId: '',
                    countryId: 0,
                    companyId: 0,
                    userId: 0,
                    sessionUsageComponentTypes: [],
                };
                SessionModelUsagesSaveObject.quoteId = quoteObj?.quoteId;
                SessionModelUsagesSaveObject.countryId = countryId;
                SessionModelUsagesSaveObject.companyId = quoteObj?.companyId;
                SessionModelUsagesSaveObject.userId = loggedUser?.user?.id;
                SessionModelUsagesSaveObject.sessionUsageComponentTypes.push(currentObj);

                currentSaveList.push(SessionModelUsagesSaveObject);
            }
        }

        console.log('currentSaveList SessionModelUsages: ', currentSaveList);
        setSaveSessionModelUsages(currentSaveList);
    };

    const handleCurrencyComponentCostsChange = (componentId, countryId, field, newValue) => {
        const error = {
            isError: false,
            countryId: 0,
            componentId: 0,
            errorField: null,
            errorTable: 'Component - External Costs/Cost per min',
            errorMessage: null,
        };

        if (isNaN(newValue) || newValue === "" || !/^[0-9]*\.?[0-9]*$/.test(newValue)) {

            error.isError = true;
            error.errorField = field;
            error.countryId = countryId;
            error.componentId = componentId;
            error.errorMessage = newValue === "" ? 'Field cannot be left blank!' : 'Please enter a valid numeric value!';
            setCurrencyComponentCostErrorValue(error);
            console.log('Entered invalid value : ', newValue);
            const findIndex = currencyComponentCostErrorArrayValue.findIndex(item => item.componentId === componentId && item.countryId === countryId && item.errorField === field)
            if (findIndex !== -1) {
                currencyComponentCostErrorArrayValue[findIndex].errorMessage = error.errorMessage;
                currencyComponentCostErrorArrayValue[findIndex].isError = error.isError;
            }
            else {

                setCurrencyComponentCostErrorArrayValue(prevArray => [...prevArray, error]);
            
            }
            return false;
        } else {
            error.isError = false;
            error.errorField = field;
            error.countryId = countryId;
            error.componentId = componentId;
            error.errorMessage = '';
             const findIndex = currencyComponentCostErrorArrayValue.findIndex(item => item.componentId === componentId && item.countryId === countryId && item.errorField === field)
            if (findIndex !== -1) {
                currencyComponentCostErrorArrayValue[findIndex].errorMessage = error.errorMessage;
                currencyComponentCostErrorArrayValue[findIndex].isError = error.isError;
            }
            else {


                setCurrencyComponentCostErrorArrayValue(prevArray => [...prevArray, error]);
              
            }
            setCurrencyComponentCostErrorValue(error);
        }



        const currentValues = [...CurrencyComponentCosts];

        const index = currentValues.findIndex(item => item.componentId === componentId && item.countryId === countryId);
        let modifiedObj = currentValues?.find(item => item.componentId === componentId && item.countryId === countryId);
        modifiedObj[field] = parseFloat(newValue);

        currentValues.splice(index, 1, modifiedObj);
        setcountryCurrencyComponentCosts([...currentValues]);

        const ExtCostVariationSaveObject = {
            quoteId: '',
            countryId: 0,
            companyId: 0,
            userId: 0,
            externalCostsTypes: [
                {
                    ssT_Cost: 0,
                    f2F_Cost: 0,
                    svC_Cost: 0,
                    stC_Cost: 0,
                    core_Cost: 0,
                    lF_Cost: 0,
                    gA_Clinical: 0,
                    gA_WL: 0,
                    managementFee: 0,
                    pepM_Cost: 0,
                    enhancedLegalServices: 0,
                    enhancedFinancialServices: 0,
                    wellnessCoaching: 0,
                }
            ],
        };

        //pre-populate old values
        currentValues?.map((item) => {
            if (item.countryId === countryId) {
                switch (item.componentId) {
                    case ExtCostVariationComponent.SST_COST:
                        ExtCostVariationSaveObject.externalCostsTypes[0].ssT_Cost = item.cost;
                        break;
                    case ExtCostVariationComponent.F2F_COST:
                        ExtCostVariationSaveObject.externalCostsTypes[0].f2F_Cost = item.cost;
                        break;
                    case ExtCostVariationComponent.SVC_COST:
                        ExtCostVariationSaveObject.externalCostsTypes[0].svC_Cost = item.cost;
                        break;
                    case ExtCostVariationComponent.STC_COST:
                        ExtCostVariationSaveObject.externalCostsTypes[0].stC_Cost = item.cost;
                        break;
                    case ExtCostVariationComponent.CORE_COST:
                        ExtCostVariationSaveObject.externalCostsTypes[0].core_Cost = item.cost;
                        break;
                    case ExtCostVariationComponent.LF_COST:
                        ExtCostVariationSaveObject.externalCostsTypes[0].lF_Cost = item.cost;
                        break;
                    case ExtCostVariationComponent.GA_CLINICAL:
                        ExtCostVariationSaveObject.externalCostsTypes[0].gA_Clinical = item.cost;
                        break;
                    case ExtCostVariationComponent.GA_WL:
                        ExtCostVariationSaveObject.externalCostsTypes[0].gA_WL = item.cost;
                        break;
                    case ExtCostVariationComponent.MANAGEMENTFEE:
                        ExtCostVariationSaveObject.externalCostsTypes[0].managementFee = item.cost;
                        break;
                    case ExtCostVariationComponent.PEPM_COST:
                        ExtCostVariationSaveObject.externalCostsTypes[0].pepM_Cost = item.cost;
                        break;
                    case ExtCostVariationComponent.ENHANCEDLEGAL:
                        ExtCostVariationSaveObject.externalCostsTypes[0].enhancedLegalServices = item.cost;
                        break;
                    case ExtCostVariationComponent.ENHANCEDFINANCIAL:
                        ExtCostVariationSaveObject.externalCostsTypes[0].enhancedFinancialServices = item.cost;
                        break;
                    case ExtCostVariationComponent.WELLNESSCOACHING:
                        ExtCostVariationSaveObject.externalCostsTypes[0].wellnessCoaching = item.cost;
                        break;
                    default:
                        break;
                }
            }
        });

        let value = newValue === "" ? 0 : parseFloat(newValue);
        //update new value
        switch (modifiedObj.componentId) {
            case ExtCostVariationComponent.SST_COST:
                ExtCostVariationSaveObject.externalCostsTypes[0].ssT_Cost = value;
                break;
            case ExtCostVariationComponent.F2F_COST:
                ExtCostVariationSaveObject.externalCostsTypes[0].f2F_Cost = value;
                break;
            case ExtCostVariationComponent.SVC_COST:
                ExtCostVariationSaveObject.externalCostsTypes[0].svC_Cost = value;
                break;
            case ExtCostVariationComponent.STC_COST:
                ExtCostVariationSaveObject.externalCostsTypes[0].stC_Cost = value;
                break;
            case ExtCostVariationComponent.CORE_COST:
                ExtCostVariationSaveObject.externalCostsTypes[0].core_Cost = value;
                break;
            case ExtCostVariationComponent.LF_COST:
                ExtCostVariationSaveObject.externalCostsTypes[0].lF_Cost = value;
                break;
            case ExtCostVariationComponent.GA_CLINICAL:
                ExtCostVariationSaveObject.externalCostsTypes[0].gA_Clinical = value;
                break;
            case ExtCostVariationComponent.GA_WL:
                ExtCostVariationSaveObject.externalCostsTypes[0].gA_WL = value;
                break;
            case ExtCostVariationComponent.MANAGEMENTFEE:
                ExtCostVariationSaveObject.externalCostsTypes[0].managementFee = value;
                break;
            case ExtCostVariationComponent.PEPM_COST:
                ExtCostVariationSaveObject.externalCostsTypes[0].pepM_Cost = value;
                break;
            case ExtCostVariationComponent.ENHANCEDLEGAL:
                ExtCostVariationSaveObject.externalCostsTypes[0].enhancedLegalServices = value;
                break;
            case ExtCostVariationComponent.ENHANCEDFINANCIAL:
                ExtCostVariationSaveObject.externalCostsTypes[0].enhancedFinancialServices = value;
                break;
            case ExtCostVariationComponent.WELLNESSCOACHING:
                ExtCostVariationSaveObject.externalCostsTypes[0].wellnessCoaching = value;
                break;
            default:
                break;
        }

        let currentSaveList = saveCurrencyComponentCosts;

        if (currentSaveList.length > 0) {
            currentSaveList.externalCostsTypes.splice(0, 1, ExtCostVariationSaveObject.externalCostsTypes[0]);
        } else {
            ExtCostVariationSaveObject.quoteId = quoteObj?.quoteId;
            ExtCostVariationSaveObject.countryId = countryId;
            ExtCostVariationSaveObject.companyId = quoteObj?.companyId;
            ExtCostVariationSaveObject.userId = loggedUser?.user?.id;

            currentSaveList = ExtCostVariationSaveObject;
        }
        console.log('currentSaveList ExtCostVariationSaveObj: ', currentSaveList);
        setSaveCountryCurrencyComponentCosts(currentSaveList);
    };
    const handleServiceDistributionsChange = (componentId, countryId, field, newValue) => {
        const error = {
            isError: false,
            countryId: 0,
            componentId: 0,
            errorField: null,
            errorTable: 'Component - Service Distribution',
            errorMessage: null,
        };

        if (isNaN(newValue) || newValue === "" || !/^[0-9]*\.?[0-9]*$/.test(newValue)) {

            error.isError = true;
            error.errorField = field;
            error.countryId = countryId;
            error.componentId = componentId;
            error.errorMessage = newValue === "" ? 'Field cannot be left blank!' : 'Please enter a valid numeric value!';
            setServiceDistributionErrorValue(error);
            const findIndex = serviceDistributionErrorArrayValue.findIndex(item => item.componentId === componentId && item.countryId === countryId && item.errorField === field)
            if (findIndex !== -1) {
                serviceDistributionErrorArrayValue[findIndex].errorMessage = error.errorMessage;
                serviceDistributionErrorArrayValue[findIndex].isError = error.isError;
            }
            else {

                setServiceDistributionErrorArrayValue(prevArray => [...prevArray, error]);
                
            }
            
            console.log('Entered invalid value : ', newValue);
            return false;
        } else {
            error.isError = false;
            error.errorField = field;
            error.countryId = countryId;
            error.componentId = componentId;
            error.errorMessage = '';
            setServiceDistributionErrorValue(error);
            ///RR-21122023
            const findIndex = serviceDistributionErrorArrayValue.findIndex(item => item.componentId === componentId && item.countryId === countryId && item.errorField === field)
            if (findIndex !== -1) {
                serviceDistributionErrorArrayValue[findIndex].errorMessage = error.errorMessage;
                serviceDistributionErrorArrayValue[findIndex].isError = error.isError;
            }
            else {

                setServiceDistributionErrorArrayValue(prevArray => [...prevArray, error]);
               
            }
            
        }

        const currentValues = [...ServiceDistributions];

        const index = currentValues.findIndex(item => item.componentId === componentId && item.countryId === countryId);
        let modifiedObj = currentValues?.find(item => item.componentId === componentId && item.countryId === countryId);
        modifiedObj[field] = parseFloat(newValue);

        currentValues.splice(index, 1, modifiedObj);
        setcomponentServiceDistributions([...currentValues]);

        let totalUtilizationPercent = 0.00;
        currentValues?.filter(x => x.countryId === countryId)?.map((item) => {
            totalUtilizationPercent += item.utilizationPercent;
        });

        if (parseFloat(totalUtilizationPercent.toFixed(10)) !== 100.00) {
            error.isError = true;
            error.errorField = field;
            error.countryId = countryId;
            error.componentId = componentId;
            error.errorMessage = `Total utilization % is not 100! Total : ${parseFloat(totalUtilizationPercent.toFixed(10))}.`;
            setServiceDistributionErrorValue(error);
        
            const findIndex = serviceDistributionErrorArrayValue.findIndex(item => item.componentId === componentId && item.countryId === countryId && item.errorField === field)
            if (findIndex !== -1) {
                serviceDistributionErrorArrayValue[findIndex].errorMessage = error.errorMessage;
                serviceDistributionErrorArrayValue[findIndex].isError = error.isError;
            }
            else {

                setServiceDistributionErrorArrayValue(prevArray => [...prevArray, error]);
                // sessiojUsageErrorArrayValue.push(newobj);
            }
            console.log('totalUtilizationPercent : ', totalUtilizationPercent);
        }

        let foundIndex;
        let currentObj;
        if (newValue !== '') {

            currentObj = {
                countryId: modifiedObj.countryId,
                productId: quoteObj?.productId,
                productVariationId: quoteObj?.productVariationId,
                componentId: modifiedObj.componentId,
                utilizationPercent: modifiedObj.utilizationPercent,
            };

        } else {

            currentObj = {
                countryId: modifiedObj.countryId,
                productId: quoteObj?.productId,
                productVariationId: quoteObj?.productVariationId,
                componentId: modifiedObj.componentId,
                utilizationPercent: (isNaN(modifiedObj.utilizationPercent) || modifiedObj.utilizationPercent === '') ? 0
                    : modifiedObj.utilizationPercent,
            };
        }

        //check if already present in save list
        const currentSaveList = [...saveServiceDistributions];

        if (currentSaveList.length > 0 && currentSaveList[0].serviceDistributionVariations[0].countryId === countryId) {
            foundIndex = currentSaveList[0].serviceDistributionVariations
                .findIndex((x) => x.componentId === currentObj.componentId
                );
        } else { foundIndex = -1; }

        if (foundIndex !== -1) {
            currentSaveList[0].serviceDistributionVariations.splice(foundIndex, 1, currentObj);
        } else {

            if (currentSaveList.length > 0) {
                currentSaveList[0].serviceDistributionVariations.push(currentObj);
            } else {
                const ServiceDistributionSaveObject = {
                    serviceDistributionVariations: [],
                    quoteId: '',
                    companyId: 0,
                    userId: 0
                };
                ServiceDistributionSaveObject.quoteId = quoteObj?.quoteId;
                ServiceDistributionSaveObject.companyId = quoteObj?.companyId;
                ServiceDistributionSaveObject.userId = loggedUser?.user?.id;
                ServiceDistributionSaveObject.serviceDistributionVariations.push(currentObj);

                currentSaveList.push(ServiceDistributionSaveObject);
            }
        }

        console.log('currentSaveList ServiceDistributionSaveObj: ', currentSaveList);
        setSavecomponentServiceDistributions(currentSaveList);

    };

    const closeNotificationPopup = () => {
        setShowNotification(false);
    };

    // Delivery Table
    const deliveryData = [
        { id: "componentName", label: '%Delivery', iseditbale: false },
        { id: "wpoDeliveredPercent", label: 'WPO (%)', iseditable: true },
        { id: "extAffiliateDelivered", label: 'Ext. Affiliate (%)', iseditable: true }
    ];
    //Session Model Usage Table
    const sessionModelHeader = [
        { id: "componentName", label: '' },
        { id: "sessionmodelsUsage", label: 'Avg. Session/Case', iseditable: false },
        { id: "usage", label: 'Session Model Usage (%)', iseditable: true }
    ];
    // Cost Table
    const costHeader = [
        { id: "componentName", label: 'Component' },
        { id: "cost", label: `External Costs`, iseditable: true },
        { id: "costPerMin", label: 'Cost per min' }
    ];
    //Distribution Table
    const distributionData = [
        { id: "componentName", label: 'Service Distribution' },
        { id: "utilizationPercent", label: 'Percentage (%)' },
        { id: "noOfCases", label: 'No.Cases' },
        { id: "noOfSessions", label: 'No.Sessions' },
        { id: "extAffCostTotalReqCurrency", label: 'External Affiliate Costs' },
        { id: "totalCostReqCurrency", label: 'Total Costs' },
        { id: "revenueStage1ReqCurrency", label: 'Revenue Stage 1' },
        /*{ id: "revenueStage1TotalReqCurrency", label: 'Total Revenue Stage 1' },*/
    ]
    

    const handleEditClick = (id) => (event) => {
        event.stopPropagation();
        SetActiveCountry(id);
        SetisEditable(true);
    }

    function validateQuoteDetails() {
        let errors = [];
        let isError = false;

        if (countryUtilizationError && countryUtilizationError !== "" && countryUtilizationError !== null) {
            errors.push(`Utilization error : ${countryUtilizationError}`);
            isError = true;
        }

        const costMinfindIndex = costMinChangeErrorArrayValue.findIndex(item => item.isError === true)
        if (costMinfindIndex >= 0) {
            errors.push(costMinChangeErrorArrayValue[costMinfindIndex].errorTable + "-" + costMinChangeErrorArrayValue[costMinfindIndex].errorTable);
            isError = true;
        }
        const sessionfindIndex = sessionUsageErrorArrayValue.findIndex(item => item.isError === true)
        if (sessionfindIndex >= 0) {
            errors.push(sessionUsageErrorArrayValue[sessionfindIndex].errorTable + "-" + sessionUsageErrorArrayValue[sessionfindIndex].errorMessage);
            isError = true;
        }
        const delivaryfindIndex = delivaryErrorArrayValue.findIndex(item => item.wpoDeliveredPercentIsError === true || item.extAffiliateDeliveredIsError === true)
        if (delivaryfindIndex >= 0) {
            if (delivaryErrorArrayValue[delivaryfindIndex].wpoDeliveredPercentIsError === true) {
                errors.push(delivaryErrorArrayValue[delivaryfindIndex].errorTable + "-" + delivaryErrorArrayValue[delivaryfindIndex].wpoDeliveredPercentErrorMessage);
                isError = true;
            }
            else if (delivaryErrorArrayValue[delivaryfindIndex].extAffiliateDeliveredIsError === true) {
                errors.push(delivaryErrorArrayValue[delivaryfindIndex].errorTable + "-" + delivaryErrorArrayValue[delivaryfindIndex].extAffiliateDeliveredErrorMessage);
                isError = true;
            }
        
        }
        const currencyfindIndex = currencyComponentCostErrorArrayValue.findIndex(item => item.isError === true)
        if (currencyfindIndex >= 0) {
            errors.push(currencyComponentCostErrorArrayValue[currencyfindIndex].errorMessage);
            isError = true;
        }
        const servicefindIndex = serviceDistributionErrorArrayValue.findIndex(item => item.isError === true)
        if (servicefindIndex >= 0) {
            errors.push(serviceDistributionErrorArrayValue[servicefindIndex].errorMessage);
            isError = true;
        }

        if (errors.length > 1) {
            setLoading(false);
            setNotificationMessage(`Invalid data found while saving Quote Details! Please check.`);
            setNotificationSeverity(Severity.ERROR);
            setShowNotification(true);
        } else if (errors.length === 1) {
            setLoading(false);
            setNotificationMessage(`Invalid data: ${errors[0]} Please check.`);
            setNotificationSeverity(Severity.ERROR);
            setShowNotification(true);
        }

        return isError;
    }

    const handleSaveClick = (id) => (e) => {
        e.stopPropagation();
        setLoadingState(true);
        setLoading(true);
        setLoadingText('Validating data...');

        const isError = validateQuoteDetails();
        if (isError) {
            setLoading(false);
            setLoadingState(false);
            return;
        }


        const quoteDetailApiToCall = [];

        if (saveDeliveryWPOExAffiliates?.length > 0) {
            quoteDetailApiToCall.push(ApiCalls.PERCENTDELIVERYWPOEXTAFF);
        }

        if (saveSessionModelUsages?.length > 0) {
            quoteDetailApiToCall.push(ApiCalls.SESSIONUSAGES);
        }

        if (saveTaskCosts?.length > 0) {
            quoteDetailApiToCall.push(ApiCalls.TASKCOSTS);
        }

        if (saveCurrencyComponentCosts && saveCurrencyComponentCosts?.externalCostsTypes?.length > 0) {
            quoteDetailApiToCall.push(ApiCalls.EXTERNALCOSTSMIN);
        }

        if (saveServiceDistributions?.length > 0) {
            quoteDetailApiToCall.push(ApiCalls.SERVICEDISTRIBUTION);
        }

        if (countryUtilizationToSave && countryUtilizationToSave !== null) {
            quoteDetailApiToCall.push(ApiCalls.COUNTRYUTILIZATION);
        }

        if (quoteDetailApiToCall?.length > 0) {
            saveDataSequentially(quoteDetailApiToCall);
        } else {
            setLoading(false);
            setLoadingState(false);
            setNotificationMessage('No changes to save!');
            setNotificationSeverity(Severity.INFO);
            setShowNotification(true);
        }

        SetActiveCountry(0);
    }

    async function saveDataSequentially(apis) {
        for (let api of apis) {
            await saveQuoteDetailsData(api);
        };
        console.log('all data saved');
        saveCalculationsDispatch();
    }

    function saveQuoteDetailsData(api) {
        switch (api) {
            case ApiCalls.PERCENTDELIVERYWPOEXTAFF: savePercentDeliveryWPOExtAffDispatch(); break;
            case ApiCalls.SESSIONUSAGES: saveSessionsUsageDispatch(); break;
            case ApiCalls.TASKCOSTS: saveComponentTaskCostsDispatch(); break;
            case ApiCalls.EXTERNALCOSTSMIN: saveExternalCostVariationsDispatch(); break;
            case ApiCalls.SERVICEDISTRIBUTION: saveServiceDistributionDispatch(); break;
            case ApiCalls.COUNTRYUTILIZATION: saveCountryUtilizationDispatch(); break;
        }
    }

    function savePercentDeliveryWPOExtAffDispatch() {
        setLoadingText('Saving data... % Delivery WPO/ExtAffiliates');
        dispatch(saveDeliveryStaffProductivityVariationAsync(saveDeliveryWPOExAffiliates[0]))
            .then((data) => {
                console.log("save DeliveryWPOExAffiliates", data);
                setSaveDeliveryWPOExAffiliates([]);
                
                setDelivaryErrorArrayValue([]);
                return data;
            })
            .catch((e) => {
                console.log(e);
                return e;
            });
    }

    function saveSessionsUsageDispatch() {
        setLoadingText('Saving data... Component - Session Usages');
        dispatch(saveSessionUsageComponentTypeVariationAsync(saveSessionModelUsages[0]))
            .then((data) => {
                console.log("save SessionModelUsages", data);
                setSaveSessionModelUsages([]);
                //RR on 25/12
                setSessionUsageErrorArrayValue([]);
                return data;
            })
            .catch((e) => {
                console.log(e);
                return e;
            });
    }

    function saveComponentTaskCostsDispatch() {
        setLoadingText('Saving data... Staff Cost Department');
        dispatch(saveStaffCostDepartmentVariationAsync(saveTaskCosts[0]))
            .then((data) => {
                console.log("save StaffCostDepartmentVariation", data);
                setSaveComponentTaskCosts([]);
                //RR on 25/12
                setCostMinChangeErrorArrayValue([]);
                return data;
            })
            .catch((e) => {
                console.log(e);
                return e;
            });
    }

    function saveExternalCostVariationsDispatch() {
        setLoadingText('Saving data... Externals Costs/Min.');
        dispatch(saveExternalCostsVariationAsync(saveCurrencyComponentCosts))
            .then((data) => {
                console.log("save ExternalCostsVariation", data);

                setSaveCountryCurrencyComponentCosts([]);
                //RR on 25/12
                setCurrencyComponentCostErrorArrayValue([]);
                return data;
            })
            .catch((e) => {
                console.log(e);
                return e;
            });
    }

    function saveServiceDistributionDispatch() {
        setLoadingText('Saving data... Service Distribution');
        dispatch(saveServiceDistribution(saveServiceDistributions[0]))
            .then((data) => {
                console.log("save ServiceDistribution", data);
                setSavecomponentServiceDistributions([]);
                //RR on 25/12
                setServiceDistributionErrorArrayValue([]);
                return data;
            })
            .catch((e) => {
                console.log(e);
                return e;
            });
    }

    function saveCountryUtilizationDispatch() {
        setLoadingText('Saving data... Country Utilization');
        const countryUtilObj = {
            quoteId: quoteObj?.quoteId,
            countryId: countryUtilizationToSave.countryId,
            utilization: countryUtilizationToSave.utilization
                && !isNaN(countryUtilizationToSave.utilization)
                && countryUtilizationToSave.utilization !== ""
                && countryUtilizationToSave.utilization !== null
                ? parseFloat(countryUtilizationToSave.utilization) : 0,
            companyId: Congiguration.CompanyId,
            userId: loggedUser?.user?.id,
        }
        dispatch(saveCountryUtilizationVariation(countryUtilObj))
            .then((data) => {
                console.log("save CountryUtilization response", data);
                setCountryUtilizationToSave(null);
                return data;
            })
            .catch((e) => {
                console.log(e);
                return e;
            });
    }

    function saveCalculationsDispatch() {
        setLoadingText('Re-calculating...');
        const saveQuoteCalculationObj = {
            quoteId: quoteObj?.quoteId,
            userId: loggedUser?.user?.id
        };
        dispatch(SaveQuoteCalculations(saveQuoteCalculationObj))
            .then((data) => {
                console.log("save QuoteCalculations", data);
                setSavecomponentServiceDistributions([]);
                updatePage();
                return data;
            })
            .catch((e) => {
                console.log(e);
                return e;
            });
    }

    function updatePage() {
        updateCalculationsAndRefreshPage(quoteObj?.quoteId);
        setLoading(false);
        setLoadingState(false);
        setNotificationMessage('Quote details successfully updated!');
        setNotificationSeverity(Severity.SUCCESS);
        setShowNotification(true);
    }

   

    function handleUtilizationChange(value, countryId) {
        console.log('value, countryId', `${value}, ${countryId}`);
        let utilizationError = QuoteDetailsConstants.UTLIZATION_NUMBER_VALID;
        if (!value) {
            utilizationError = Constant.UTLIZATION_NUMBER_REQUIRED;
        } else if (!/^[0-9]*\.?[0-9]*$/.test(value) ||value==='.' ) {
            utilizationError = Constant.UTLIZATION_NUMBER_VALID;
        } else {
            const utilizationNumber = parseFloat(value);
            if (utilizationNumber <= 0) {
                utilizationError = Constant.UTLIZATION_NUMBER_GREATER;
            }
            else {
                utilizationError = "";
                setCountryUtilizationToSave({ countryId: countryId, utilization: value?.trim() });
            }
        }
        setCountryUtilizationError(utilizationError);
    }

    function getUtilization(utilizationVal, countryId) {
        return (
            <>
                <TextField
                    className = "txtUtilization"
                    size="small"
                    defaultValue={utilizationVal}
                    onChange={(e) => handleUtilizationChange(e.target.value, countryId)}
                />
               
                <div style={{ height: "20px",marginTop:"25px",textAlign:'left' }}> {countryUtilizationError && countryUtilizationError !== "" && countryUtilizationError !== null &&
                    < Typography variant="caption" sx={{ color: red[500], fontSize: '10px', whiteSpace: 'nowrap' }} display="block" gutterBottom>
                        {countryUtilizationError}
                    </Typography>}</div>
            </>
        )
    }

    return (
        <>
            <QuoteDetailsSection style={{ position: 'relative' }}>

                <Box className="quotedetailWrapper">
                    <Accordion expanded={true}>
                        <AccordionSummary
                            className='accordianmain'
                            aria-controls="panel1a-content"
                            id="panel1a-header"

                        >
                            <div className='accordianheading'>Country</div>
                            <div className='accordianheading'>Product</div>
                            <div className='accordianheading'> Currency </div>
                            <div className='accordianheading'>HeadCount</div>
                            <div className='accordianheading'></div>
                        </AccordionSummary>
                        <AccordionDetails sx={{ padding: "30px" }}>
                            <Accordion expanded={true}>
                                <AccordionSummary
                                    className='countryaccordian'
                                    aria-controls="panel1a-content"
                                    id="panel1a-header"

                                >
                                    <div className='accordianheading'>All Countries</div>
                                    <div className='accordianheading'>{product}</div>
                                    <div className='accordianheading'> {currencyCode} </div>
                                    <div className='accordianheading'>{totslheadount?.toLocaleString()}</div>
                                    <div className='accordianheading'></div>
                                </AccordionSummary>

                                <AccordionDetails sx={{ padding: "30px 0px 0px 0px" }}>
                                    {loading &&
                                        <Box sx={{ width: '100%', zIndex: 1300 }}>
                                            <CircularProgress />
                                            <Typography variant="subtitle1" gutterBottom>
                                                {loadingText}
                                            </Typography>
                                        </Box>}
                                    <Box className="countrybox">
                                        {visibleData?.map((country) => (
                                            <Box className="accordianFirst">
                                                <Accordion>
                                                    <AccordionSummary
                                                        className='detailaccordian'
                                                        expandIcon={<ExpandMoreIcon />}
                                                        aria-controls="panel1a-content"
                                                        id="panel1a-header"
                                                    >
                                                        <div className='accordianheading'>{country.countryName}</div>
                                                        <div className='accordianheading'>{country.productName}</div>
                                                        <div className='accordianheading'> {country.currencyCode} </div>
                                                        <div className='accordianheading'>{country.headcount?.toLocaleString()}</div>
                                                        <div className='accordianheading'>
                                                            {isEditQuoteStatus && activeCountry !== country.countryId && <Button disabled={loading} onClick={handleEditClick(country.countryId)}><ModeEditIcon fontSize='small' />Edit</Button>}
                                                            {isEditQuoteStatus && activeCountry === country.countryId && <Button disabled={loading} onClick={handleSaveClick(country.countryId)}><SaveIcon fontSize='small' />{loading ? <span>Saving..</span> : <span>Save</span>}</Button>}
                                                        </div>
                                                    </AccordionSummary>
                                                    <AccordionDetails >
                                                        <Box className="customerStatus">
                                                            <Box className="d-flex">
                                                                <div className="customerDetails">
                                                                    <div className="contentUser">
                                                                        <h4>SessionModel</h4>
                                                                        <p className={`para0`}>{pricing?.countryHeadCountSessionUtils?.find(x => x.countryId === country.countryId)?.sessions}</p>
                                                                    </div>
                                                                </div>
                                                                <div className="customerDetails">
                                                                    <div className="contentUser">
                                                                        <h4>HeadCount</h4>
                                                                        <p className={`para0`}>{pricing?.countryHeadCountSessionUtils?.find(x => x.countryId == country.countryId)?.headCount.toLocaleString()}</p>
                                                                    </div>
                                                                </div>
                                                                <div className="customerDetails">
                                                                    <div className="contentUser">
                                                                        <h4>Utilization</h4>
                                                                        <p className={`para0`}>{isEditQuoteStatus && activeCountry === country.countryId
                                                                            ?
                                                                            getUtilization(pricing?.countryHeadCountSessionUtils?.find(x => x.countryId == country.countryId)?.utilization, country.countryId)
                                                                            :
                                                                            `${pricing?.countryHeadCountSessionUtils?.find(x => x.countryId == country.countryId)?.utilization.toLocaleString()} %`}</p>
                                                                    </div>
                                                                </div>
                                                                <div className="customerDetails">
                                                                    <div className="contentUser">
                                                                        <h4>% Clinical</h4>
                                                                        <p className={`para0`}>{pricing?.countryHeadCountSessionUtils?.find(x => x.countryId == country.countryId)?.clinicalPercent.toLocaleString()}%</p>
                                                                    </div>
                                                                </div>
                                                                <div className="customerDetails">
                                                                    <div className="contentUser">
                                                                        <h4>% Worklife</h4>
                                                                        <p className={`para0`}>{pricing?.countryHeadCountSessionUtils?.find(x => x.countryId == country.countryId)?.workLifePercent.toLocaleString()}%</p>
                                                                    </div>
                                                                </div>
                                                                <div className="customerDetailstwo">
                                                                    <div className="contentUser">
                                                                        <h4>Account Manager Hours</h4>
                                                                        <p className={`para0`}>{pricing?.countryHeadCountSessionUtils?.find(x => x.countryId === country.countryId)?.accountManagementHours?.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} hrs</p>
                                                                    </div>
                                                                </div>
                                                            </Box>
                                                        </Box>
                                                        <Box className="tablewrapper">
                                                            <Box className="tableRight">
                                                                <DeliveryTable headers={deliveryData} handleChange={handleDelivaryChange} rows={quotePricing?.percentDeliveryWPOExAffiliates?.filter(x => x.countryId === country.countryId)} isEditable={activeCountry === country.countryId ? true : false} error={delivaryErrorArrayValue} />
                                                            </Box>
                                                            <Box className="tableLeft">
                                                                <ObjectTable headers={sessionModelHeader} handleChange={handleSessionModelUsagesChange} 
                                                                rows={quotePricing?.componentSessionModelUsages?.filter(x => x.countryId === country.countryId).length===0?null:quotePricing?.componentSessionModelUsages?.filter(x => x.countryId === country.countryId)} isEditable={activeCountry === country.countryId ? true : false} error={sessionUsageErrorArrayValue} />
                                                            </Box>
                                                        </Box>
                                                        <Box className="sessionTable">
                                                            <TaskComponentTable headers={quotePricing?.tasks} handleChange={handleCostMinChange} rows={quotePricing?.componentTaskCosts?.filter(x => x.countryId === country.countryId)} isEditable={activeCountry === country.countryId ? true : false} error={costMinChangeErrorArrayValue} />
                                                        </Box>
                                                        <Box className="sessionTable">
                                                            <ObjectTable headers={costHeader} handleChange={handleCurrencyComponentCostsChange} rows={quotePricing?.countryCurrencyComponentCosts?.filter(x => x.countryId === country.countryId)} isEditable={activeCountry === country.countryId ? true : false} error={currencyComponentCostErrorArrayValue} />
                                                        </Box>
                                                        <Box className="distributionTable">
                                                            <ServiceDistributionTable headers={distributionData} handleChange={handleServiceDistributionsChange} isEditable={activeCountry === country.countryId ? true : false} rows={quotePricing?.componentServiceDistributions?.filter(x => x.countryId === country.countryId)} error={serviceDistributionErrorArrayValue} requestedCurrency={country.currencyCode} productId={quoteObj?.productId} />
                                                        </Box>
                                                        <Box className="priceTable">
                                                            <ObjectTable headers={allInPriceHeader} captionText={quoteObj?.productId === AllProductsEnum.EAP ? Constant.QUOTEDETAILEAP : ""} rows={pricingdata?.filter(x => x.countryId === country.countryId)} isEditable={activeCountry === country.countryId ? true : false} />
                                                        </Box>

                                                    </AccordionDetails>
                                                </Accordion>
                                            </Box>
                                        ))}
                                        {(isLoading||!(visibleData?.length>0)) && <div>Loading...</div>}
                                    </Box>
                                </AccordionDetails>
                            </Accordion>
                        </AccordionDetails>
                    </Accordion>
                </Box>
                <ScrollToTopButton />
            </QuoteDetailsSection>
            {showNotification && (
                <Notification
                    open={showNotification}
                    onClose={closeNotificationPopup}
                    message={notificationMessage}
                    severity={notificationSeverity}
                />
            )}
            {loadingState && <Loader open={loadingState} />}
        </>

    )
}

export default QuoteDetail;